module.exports = __webpack_public_path__ + "band_15.5ccd2b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_15.png
// module id = 5VSS
// module chunks = 0